module.exports = function () {
	$('.js_modalImg').colorbox({
		maxWidth: '100%'
	});
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/modal.js
// module id = 6
// module chunks = 0